import { useEffect, useState } from "react";
import { eventBus } from "../events/eventBus";

/**
 * Lightweight hook that listens to TOOTH_EVENTs and
 * returns the currently animated tooth code.
 *
 * Animation itself is handled by CSS classes in ToothChart.
 */
export function useToothAnimation(): string | null {
  const [animated, setAnimated] = useState<string | null>(null);

  useEffect(() => {
    const handler = (event: { tooth?: string } | unknown) => {
      const e = event as { tooth?: string } | null;
      if (!e || !e.tooth) return;

      setAnimated(e.tooth);

      const timeout = setTimeout(() => {
        setAnimated((current) => (current === e.tooth ? null : current));
      }, 500);

      return () => clearTimeout(timeout);
    };

    eventBus.on("TOOTH_EVENT", handler);
    return () => {
      eventBus.off("TOOTH_EVENT", handler);
    };
  }, []);

  return animated;
}
